import { NOTIFICATION_TYPE, showNotification } from '@thinknet-gmbh/platform-common-ui';
import { gql, useMutation } from '@apollo/client';

import { GET_VACANCIES } from 'src/hooks/vacancies-patterns/get-vacancies.hook';

import { GET_APPLICANTS_BY_VACANCY } from './get-applicants-by-vacancy.hook';

export const CREATE_APPLICANT = gql`
  mutation createApplicant($payload: CreateApplicantInput!) {
    createApplicant(payload: $payload) {
      _id
    }
  }
`;

export const useCreateApplicant = () => {
  const [createApplicant, { loading }] = useMutation(CREATE_APPLICANT, {
    refetchQueries: [GET_VACANCIES, GET_APPLICANTS_BY_VACANCY],
    onCompleted: data =>
      data &&
      showNotification({
        type: NOTIFICATION_TYPE.success,
        message: 'Ihre Angaben werden gespeichert',
      }),

    onError: error => {
      if (error.message === 'email-already-exists') {
        return showNotification({
          type: NOTIFICATION_TYPE.error,
          message: 'Es gibt bereits ein Konto mit dieser Email Adresse.',
        });
      }
    },
  });

  return { createApplicant, loading };
};
